import React from 'react'
import { Col, Row } from 'antd'

const MaterialItem = ({ material }) => {
  return (
    <div>
      <Row gutter={8} align="middle">
        <Col>
          <img src={material.image} alt="" width={64} height={64} />
        </Col>
        <Col>
          <span>{material.name}</span>
        </Col>
      </Row>
    </div>
  )
}

export default MaterialItem



// WEBPACK FOOTER //
// ./src/components/MaterialItem/index.js